//
// 특정 GraphQL 오퍼레이션만 별도의 X-Target-Server 헤더 값으로 일괄(bulk) 분기한다.
// (로컬 개발에서 일부 API만 다른 서버 인스턴스로 보내고 싶을 때 사용)
//
// 사용법:
//   1) TARGET_SERVER_VALUE 에 분기 대상 API들이 사용할 X-Target-Server 값을 지정
//      - ''     : 베이스/운영 인스턴스로 라우팅 (프록시 기본)
//      - 'dev'  : dev 인스턴스
//      - 그 외 프록시가 인식하는 값
//   2) TARGET_SERVER_OPERATIONS 배열에 분기할 GraphQL 오퍼레이션명을 추가하면 됨
//
// 실제 적용은 App.js 의 axios 요청 인터셉터에서 이루어지며, 개발(dev) 빌드에서만 동작한다.
//

// 분기 대상 API에 일괄 적용할 X-Target-Server 값 (← 원하는 값으로 변경)
export const TARGET_SERVER_VALUE = 'bulk';

// 분기할 GraphQL 오퍼레이션명 배열 (← 여기에 추가만 하면 해당 API가 위 값으로 분기됨)
export const TARGET_SERVER_OPERATIONS = [
  'setProductSync', // /easySetting 상품 가져오기
  'setReviewSync',  // /easySetting 리뷰 가져오기
  'getReviewsForCopy',  // /reviewCopy 복사할 리뷰 조회
  'getCopiedSourceMap', // /reviewCopy 기복사 소스 매핑 조회
  'runReviewCopy',      // /reviewCopy 리뷰 복사 실행
];

// operationName 이 분기 대상인지 여부
export const isTargetServerOperation = (operationName) =>
  !!operationName && TARGET_SERVER_OPERATIONS.indexOf(operationName) !== -1;

// 개별 오퍼레이션을 특정 X-Target-Server 값으로 보내는 매핑 (개발 빌드 전용).
// 신규 백엔드 리졸버가 운영(widget/base) 인스턴스에 아직 배포되지 않고 dev 인스턴스에만
// 있을 때, 운영 반영(FTP) 전까지 dev 로 라우팅해 로컬에서 테스트할 수 있게 한다.
// 운영 빌드에서는 적용되지 않으므로(아래 NODE_ENV 가드), 배포 후 기본 라우팅으로 동작한다.
export const DEV_OPERATION_TARGET_SERVER = {
  getShopMileageStatus: 'dev',
  getUserMileageHistoryByStore: 'dev',
  getOrphanMileageConfigs: 'dev',
  deleteOrphanMileageConfig: 'dev',
  deleteOrphanMileageConfigs: 'dev',
};

// 오퍼레이션에 적용할 X-Target-Server 값을 반환한다 (해당 없으면 null).
export const getTargetServerForOperation = (operationName) => {
  if (!operationName) return null;
  if (process.env.NODE_ENV === 'development'
      && Object.prototype.hasOwnProperty.call(DEV_OPERATION_TARGET_SERVER, operationName)) {
    return DEV_OPERATION_TARGET_SERVER[operationName];
  }
  if (TARGET_SERVER_OPERATIONS.indexOf(operationName) !== -1) return TARGET_SERVER_VALUE;
  return null;
};
